export default __webpack_public_path__ + "static/media/hand-rock-blk.bb078fc8.svg";